module.exports = __webpack_public_path__ + "img/partner-2.c2b2f174.png";